import {
    SET_BOOKMARKED_SESSIONS,
    SET_BOOKMARKED_SESSIONS_INITIATED_FETCH,
} from '../actions/bookmarkedSessions';

const initialState = {
    data: null,
    initiatedFetch: false,
};

function bookmarkedSessions(state = initialState, action) {
    const { payload, type } = action;
    switch (type) {
        case SET_BOOKMARKED_SESSIONS:
            return { ...state, data: payload };
        case SET_BOOKMARKED_SESSIONS_INITIATED_FETCH:
            return { ...state, initiatedFetch: payload };
        default:
            return state;
    }
}

export default bookmarkedSessions;
